export default "__VITE_ASSET__Cftdj_sU__"